import React, { useState, useRef } from 'react';
import PropTypes from 'prop-types';
import { Form } from 'react-bootstrap';
import DatePicker from 'react-datepicker';

const DateRangeFilter = ({ label, id, onChange, startDate, endDate }) => {
    const [dpStartDate, setStartDate] = useState(startDate ? new Date(startDate) : null);
    const [dpEndDate, setEndDate] = useState(endDate ? new Date(endDate) : null);
    const datePickerRef = useRef(null);

    const formatDate = (date) => {
        if (!date) return '';
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const year = date.getFullYear();
        return `${day}.${month}.${year}`;
    };

    const updateHiddenInputs = (start, end) => {
        if (start) {
            document.getElementById(`${id}Start`).value = formatDateForBackend(start);
        } else {
            document.getElementById(`${id}Start`).value = '';
        }

        if (end) {
            document.getElementById(`${id}End`).value = formatDateForBackend(end);
        } else {
            document.getElementById(`${id}End`).value = '';
        }
    };

    const formatDateForBackend = (date) => {
        if (!date) return '';
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const year = date.getFullYear();
        return `${year}-${month}-${day}`;
    };

    const handleDateChange = dates => {
        const [start, end] = dates;
        setStartDate(start);
        setEndDate(end);

        updateHiddenInputs(start, end);

        if (onChange && (start || (dpStartDate && !start))) {
            onChange();
        }
    };

    const handleKeyDown = (e) => {
        if (![9, 27, 37, 38, 39, 40].includes(e.keyCode)) {
            e.preventDefault();
        }
    };

    const handleClick = () => {
        if (datePickerRef.current) {
            datePickerRef.current.setOpen(true);
        }
    };

    const currentYear = new Date().getFullYear();
    const yearRange = 10;

    return (
        <>
            <Form.Group className="select-wrapper">
                <Form.Label htmlFor={id}>{label}</Form.Label>
                <DatePicker
                    id={id}
                    name={id}
                    ref={datePickerRef}
                    selected={dpStartDate}
                    onChange={handleDateChange}
                    startDate={dpStartDate}
                    endDate={dpEndDate}
                    selectsRange
                    dateFormat="dd.MM.yyyy"
                    className="form-control"
                    placeholderText="Select date range"
                    minDate={new Date(currentYear - yearRange, 0, 1)}
                    maxDate={new Date(currentYear + yearRange, 11, 31)}
                    isClearable
                    yearDropdownItemNumber={5}

                    onKeyDown={handleKeyDown}
                    onClick={handleClick}
                    showMonthDropdown
                    showYearDropdown
                    dropdownMode="select"
                    autoComplete="off"
                    popperPlacement="bottom-start"
                />
               
                <input type="hidden" id={`${id}Start`} name={`${id}Start`} />
                <input type="hidden" id={`${id}End`} name={`${id}End`} />
            </Form.Group>
        </>
    );
};

DateRangeFilter.propTypes = {
    label: PropTypes.string,
    id: PropTypes.string,
    onChange: PropTypes.func,
    startDate: PropTypes.string,
    endDate: PropTypes.string
};

export default DateRangeFilter;